import React, { Suspense } from 'react';
import cn from 'classnames';
import Loader from '@components/common/Loader/newLoaderModal';
import { LABEL, CUSTOM_MESSAGES } from '@veriables';
import { ReactComponent as Cross } from '@assets/images/cross.svg';

const Modal = React.lazy(() => import('@components/common/Modal'));

const CancelOrderModal = ({
  cancelOrderConfirm,
  setCancelOrderConfirm,
  isCounter,
  goToChecks,
  serverAppTheme,
}) => {
  if (!cancelOrderConfirm) return null;

  return (
    <Suspense fallback={<Loader />}>
      <Modal isOpen={cancelOrderConfirm} isModalCenter>
        <div className="col-12 my-2 px-0 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className={cn(isCounter ? 'fs-34' : 'fs-24', 'px-2 text-right')}>
            <Cross
              fill={serverAppTheme?.iconcolor}
              onClick={() => setCancelOrderConfirm(false)}
            />
          </div>
          <div className="col-12 fs-18 fw-700 text-center">
            {CUSTOM_MESSAGES().CANCEL_ORDER}
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button
              type="submit"
              className="col-4 m-2 btn btn-secondary od-btn-secondary"
              onClick={() => setCancelOrderConfirm(false)}
            >
              <div className="fs-18">{LABEL().NO}</div>
            </button>
            <button
              type="submit"
              className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary"
              onClick={() => goToChecks()}
            >
              <div className="fs-18">{LABEL().YES}</div>
            </button>
          </div>
        </div>
      </Modal>
    </Suspense>
  );
};

export default CancelOrderModal;
